export const BADGES = 'badges'

export const TEST_RESULTS = 'test_results'
